import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWorkbenchIssueService = ( createDecorator('workbenchIssueService'));
export { IWorkbenchIssueService };
